var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',[_vm._l((_vm.navigation),function(item){return [(item.items)?_c('NavigationList',{key:item.key,attrs:{"value":item}}):_c('NavigationItem',{key:item.key,attrs:{"value":item}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }